import * as React from 'react'

import { FilterButton } from '~/client/src/shared/components/Filters/triggers'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useMobileResourceActions, useMobileResourceState } from '../context'

export const MobileResourceFilterButton: React.FC = () => {
  const { selectedFilterCount } = useMobileResourceState()
  const { openFilter } = useMobileResourceActions()

  return (
    <FilterButton
      label={Localization.translator.filter}
      badgeCount={selectedFilterCount || undefined}
      onClick={openFilter}
      iconOnly
      size="lg"
    />
  )
}
